import React, { useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { Collapse, makeStyles } from "@material-ui/core";
import { color, motion } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import AllCountries from "../../components/v4/AllCountries/AllCountries";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";

import whiteCheckCircle from "../../images/v4/whatsappPage/icons/whiteCheckCircle.svg";
import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";
import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";
import bodySectionBg from "../../images/v4/country/thailand/images/bodySectionBg.png";
import heroBg from "../../images/v4/country/thailand/images/heroBg.png";

import thailand from "../../images/v4/country/thailand/icons/thailand.svg";

import bestIcon1 from "../../images/v4/country/india/icons/bestIcon1.svg";
import bestIcon2 from "../../images/v4/country/india/icons/bestIcon2.svg";
import bestIcon3 from "../../images/v4/country/india/icons/bestIcon3.svg";
import bestIcon4 from "../../images/v4/country/india/icons/bestIcon4.svg";
import bestIcon5 from "../../images/v4/country/india/icons/bestIcon5.svg";

import smartIcon1 from "../../images/v4/country/india/icons/smartIcon1.svg";
import smartIcon2 from "../../images/v4/country/india/icons/smartIcon2.svg";
import smartIcon3 from "../../images/v4/country/india/icons/smartIcon3.svg";
import smartIcon4 from "../../images/v4/country/india/icons/smartIcon4.svg";
import smartIcon5 from "../../images/v4/country/india/icons/smartIcon5.svg";
import smartIcon6 from "../../images/v4/country/india/icons/smartIcon6.svg";
import smartIcon7 from "../../images/v4/country/india/icons/smartIcon7.svg";
import smartIcon8 from "../../images/v4/country/india/icons/smartIcon8.svg";
import smartIcon9 from "../../images/v4/country/india/icons/smartIcon9.svg";

import partnerIcon1 from "../../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../../images/v4/aiPage/icons/partnerIcon8.png";

import compareItemImg1 from "../../images/v4/industry/education/images/compareItemImg1.png";
import compareItemImg2 from "../../images/v4/industry/education/images/compareItemImg2.png";
import compareItemImg3 from "../../images/v4/industry/education/images/compareItemImg3.png";
import compareItemImg4 from "../../images/v4/industry/education/images/compareItemImg4.png";
import compareItemImg5 from "../../images/v4/country/malaysia/images/compareItemImg5.png";

import countryBackground from "../../images/v4/country/thailand/images/countryBackground.png";
import benefitImg from "../../images/v4/country/thailand/images/benefitImg.png";

import realWorldImg1 from "../../images/v4/country/thailand/images/realWorldImg1.png";
import realWorldImg2 from "../../images/v4/country/thailand/images/realWorldImg2.png";
import realWorldImg3 from "../../images/v4/country/thailand/images/realWorldImg3.png";
import realWorldImg4 from "../../images/v4/country/thailand/images/realWorldImg4.png";
import SEO from "../../components/SEO";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    background: `url(${heroBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    padding: "100px 0 60px",
    "& .countryHighlight": {
      background: "linear-gradient(91deg, #FF1D5A 14.05%, #007DE9 38.11%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "16px",
      width: "85%",
      margin: "0 auto",
      textAlign: "center",
      "& .buttonContaienr": {
        justifyContent: "center",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
        marginTop: "0px",
        "& .buttonContaienr": {
          alignItems: "center",
        },
        "& .primaryButton": {
          width: "100%",
        },
        "& .countryLogo": {
          width: "30px",
        },
      },
    },
    "@media only screen and (max-width: 600px)": {
      padding: "0",
    },
  },
  listContainer: {
    display: "flex",
    marginTop: "16px",
    // flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minWidth: "100%",
      gap: "15px",
    },
  },
  listItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    border: "1px solid #00B661",
    borderRadius: "50px",
    padding: "10px 15px",
    minWidth: "max-content",
    "@media only screen and (max-width: 600px)": {
      minWidth: "90%",
    },
    // color: "#A2BED3",
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& $supportBox": {
      position: "absolute",
      top: "-410px",
      background: "linear-gradient(180deg, #009A99 0%, #1C297E 100%)",
    },
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "540px",
      "& $supportBox": {
        top: "-770px",
      },
      "& .header": {
        width: "100%",
      },
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: 0,
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0 15px",
  },
  partnerSlide: {
    width: "185px !important",
    "& img": {
      width: "185px",
      filter: "brightness(0.1)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "140px !important",
      marginRight: "30px !important",
      "& img": {
        width: "140px",
        filter: "brightness(0.1)",
      },
    },
  },
  partnerSlider: {
    padding: "10px 0 40px !important",
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px !important",
    },
  },
  stripSection: {
    backgroundColor: "#e9f4fe",
    // backgroundImage: `url(${partnerSectionBackground})`,
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    "& .centerContainer": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        textAlign: "center",
      },
    },
  },
  testimonials: {
    background: "#e9f4fe",
  },
  wpFaq: {
    padding: "40px 0",
    background: "#eaffff",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  commonPageFooterSection: {
    background: "linear-gradient(to right, #011d32 -1%, #00182b 100%)",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  growingBusiness: {
    //paddingTop: "60px",
    backgroundImage: `url(${bodySectionBg})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    paddingBottom: "300px",
    position: "relative",
    "& .header": {
      width: "50%",
      textAlign: "left",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "& .body": {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "stretch",
      gap: "20px",
      flexWrap: "wrap",
      marginTop: "60px",
    },
    "& $featureContainer": {
      gap: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "60px 0 300px",
      "& .header": {
        width: "100%",
      },
    },
    "& $broadcastLeftContainer": {
      width: "55%",
    },
  },
  practiceCard: {
    background: "#ffffff1a",
    borderRadius: "16px",
    padding: "24px",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    gap: "16px",
    width: "32%",
    opacity: "1",
    backdropFilter: "blur(30px) brightness(1)",
    transition: "0.3s ease",
    "&:hover": {
      backdropFilter: "blur(50px) brightness(1.2)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  countrySection: {
    padding: "60px 0",
    borderRadius: "40px 40px 0 0",
    backgroundImage: `url(${countryBackground})`,
    backgroundSize: "cover",
    "& .header": {
      width: "60%",
      textAlign: "left",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .cards": {
      display: "flex",
      width: "100%",
      justifyContent: "flex-start",
      gap: "20px",
      alignItems: "stretch",
      marginTop: "60px",
      "@media only screen and (max-width: 600px)": {
        flexDirection: "column",
        marginTop: "40px",
      },
    },
    "& .card": {
      padding: "32px 24px",
      borderRadius: "16px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "32px",
      backdropFilter: "blur(20px)",
      border: "1px solid #534B69 ",
      width: "48%",
      background:
        "linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3))",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      padding: "0",
    },
  },
  tabsSection: {
    background: "#E9F3FD",
    paddingTop: "280px",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "& $supportBox": {
      position: "absolute",
      top: "-530px",
      "@media only screen and (max-width: 600px)": {
        top: "-800px",
        marginTop: 0,
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "550px",
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  tabsContainer: {
    width: "90%",
    minWidth: "max-content",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    border: "2px solid #DBDBDB",
    borderRadius: "40px",
    background: "#fff",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "10px",
      padding: "5px",
      overflow: "auto",
      minWidth: "100%",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
  tab: {
    width: "25%",
    minWidth: "max-content",
    background: "",
    padding: "18px",
    background: "transparent",
    borderRadius: "40px",
    background: "transparent",
    transition: "0.3s ease",
    cursor: "pointer",
    "&.active": {
      color: "white",
      background:
        "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "10px 15px",
    },
  },
  tabCard: {
    marginTop: "20px",
    gap: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    "@media only screen and (max-width: 600px)": {
      marginTop: "30px",
      flexDirection: "column",
    },
  },
  tabCardLeftContainer: {
    width: "50%",
    display: "flex",
    gap: "40px",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      gap: "20px",
      width: "100%",
    },
  },
  benfitListContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "30px",
    marginTop: "50px",
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  benfitListItem: {
    display: "flex",
    width: "100%",
    margin: "0 auto",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  benfitListItemContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "10px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  tabCardRightContainer: {
    width: "50%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  benfitIcon: {
    position: "relative",
    top: "5px",
  },
  supportBox: {
    top: "100%",
    width: "100%",
    display: "flex",
    padding: "40px",
    background: "linear-gradient(180deg, #009A99 -7.76%, #002C51 100%)",
    position: "relative",
    alignItems: "center",
    borderRadius: "20px",
    backdropFilter: "blur(30px)",
    justifyContent: "space-between",
    "& $broadcastLeftContainer": {
      width: "55%",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      width: "94%",
      padding: "15px",
      marginTop: "20px",
      gap: "20px",
    },
  },
  pointers: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "20px",
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
    },
  },
  broadcastLeftContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "60%",
    gap: "32px",
    textAlign: "left",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "20px",
    },
  },
  broadcastRightContainer: {
    width: "40%",
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        width: "100%",
      },
    },
  },
  broadcastImg: {
    "& img": {
      width: "100%",
      position: "relative",
      bottom: "0",
    },
  },
  adaptFeatures: {
    backgroundrepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${heroBg})`,
    "& .header": {
      display: "flex",
      width: "55%",
      gap: "10px",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      textAlign: "left",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .container": {
      paddingBottom: "35px",
    },
  },
  adaptSlider: {
    "@media only screen and (max-width: 600px)": {
      padding: "15px 15px 40px",
    },
    "@media only screen and (min-width: 1400px)": {
      padding: "15px 8rem 60px",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "15px 23rem 60px",
    },
  },
  adaptsBox: {
    gap: "16px",
    display: "flex",
    padding: "24px",
    background: "#fff",
    alignItems: "stretch",
    borderRadius: "20px",
    flexDirection: "column",
    justifyContent: "flex-start",
    boxShadow: "0px 0px 24px #D4E0E9",
    borderRadius: "16px",
    maxWidth: "380px",
    minHeight: "220px",
    "@media only screen and (max-width: 600px)": {
      padding: "15px",
      maxWidth: "80%",
      gap: "15px",
    },
  },
  adaptBoxHeader: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "16px",
  },
}));

const Thailand = () => {
  const classes = useStyles();
  const [activeCompare, setActiveCompare] = useState("#section0");
  const [activeAccordian, setActiveAccordian] = useState(0);
  const [activeRealWorld, setActiveRealWorld] = useState(0);
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  const partners = [
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
  ];
  const faqs = [
    {
      question:
        "What is the leading CRM software for small businesses operating in Thailand?",
      answer: (
        <>
          Pepper Cloud CRM is specifically engineered for Thai SMEs, providing
          an affordable, feature-rich platform designed to support growth
          effectively in the local market.
        </>
      ),
    },
    {
      question: "How can my growing Thai business start using a CRM?",
      answer: (
        <>
          Implementing Pepper Cloud CRM in Thailand is straightforward. Whether
          launching a startup or scaling an enterprise, our platform simplifies
          managing leads, sales activities, and client relationships.
          <ul>
            <li>
              Schedule a complimentary demo for a personalised tour of Pepper
              Cloud CRM's capabilities.
            </li>
            <li>
              Consult with our dedicated Thailand CRM specialists to identify
              the optimal plan and features for your company.
            </li>
            <li>
              Experience a simple setup process with no hidden fees or
              unnecessary complexity.
            </li>
            <li>
              Tailor the CRM configuration to perfectly align with your unique
              sales processes, pipelines, and automation requirements.
            </li>
            <li>
              Deploy quickly and begin scaling your Thai business using advanced
              AI-powered tools.
            </li>
          </ul>
        </>
      ),
    },
    {
      question:
        "What key factors should I consider when selecting a CRM for my business in Thailand?",
      answer: (
        <>
          <ul>
            <li>
              Future-proof scalability: Choose a CRM capable of expanding
              alongside your business, handling more data, users, and leads
              seamlessly.
            </li>
            <li>
              Adaptability: Ensure the CRM can be customised to fit your
              specific industry workflows, sales stages, and operational
              processes in Thailand.
            </li>
            <li>
              Integration power: Verify compatibility with essential tools used
              in Thailand, such as WhatsApp, Google Workspace, and key marketing
              software.
            </li>
            <li>
              Localised support: Prioritise providers offering accessible,
              knowledgeable support within Thailand for timely help and smooth
              onboarding.
            </li>
            <li>
              Transparent value: Seek CRM solutions with clear, fair pricing
              structures that deliver tangible value without unexpected costs.
            </li>
          </ul>
        </>
      ),
    },
    {
      question:
        "Is Pepper Cloud CRM a good fit for startup companies in Thailand?",
      answer: (
        <>
          Definitely. Pepper Cloud CRM is highly scalable, simple to deploy, and
          equipped with powerful automation features designed to accelerate
          growth for Thai startups.
        </>
      ),
    },
    {
      question: "Can Pepper Cloud CRM connect with the tools I already use?",
      answer: (
        <>
          Yes, Pepper Cloud CRM integrates smoothly with common business tools
          including email platforms, web forms, calendars, and various
          third-party applications relevant to the Thai market.
        </>
      ),
    },
    {
      question: "How does Pepper Cloud CRM handle data security?",
      answer: (
        <>
          We employ robust, multi-layered security measures and protocols to
          safeguard your customer data and help ensure compliance with relevant
          regulations.
        </>
      ),
    },
    {
      question: "What CRM systems are commonly adopted in Thailand?",
      answer: (
        <>
          While several international CRMs have a presence, Pepper Cloud CRM is
          rapidly gaining preference among Thai SMEs. This is due to its
          intuitive design, competitive pricing, and features specifically
          valuable in the Thai context, such as strong WhatsApp integration and
          dedicated regional support.
        </>
      ),
    },
    {
      question: "Is Pepper Cloud CRM expensive?",
      answer: (
        <>
          No, Pepper Cloud CRM offers flexible pricing models suitable for
          businesses of all sizes in Thailand, from new startups to established
          enterprises. You invest only in the features required, ensuring it's a
          cost-effective solution for improving sales, marketing, and support
          efficiency.
        </>
      ),
    },
    {
      question: "What defines the best CRM for a small business?",
      answer: (
        <>
          An ideal CRM for small businesses should be budget-friendly,
          user-friendly, and scalable. Pepper Cloud CRM meets these criteria
          perfectly for small businesses in Thailand, offering an intuitive
          interface, valuable AI automation, and seamless integration with key
          communication tools like WhatsApp effectively manage leads and build
          customer loyalty.
        </>
      ),
    },
  ];

  const compareItems = [
    "Pepper Cloud CRM",
    "HubSpot CRM",
    "Salesforce",
    "Zoho CRM",
    "Microsoft Dynamics 365",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud CRM emerges as the leading option for Thai businesses seeking a feature-rich, locally-attuned solution. Its all-encompassing platform provides robust lead management, AI capabilities, workflow automation, and vital WhatsApp/LINE integration, making it ideal for Thailand's unique market dynamics.",
      img: compareItemImg1,
      alt: "",
      features: [
        {
          title: "AI Assistance suite",
          desc: "Optimise operations with chatbots, real-time sales guidance, and automated task management.",
        },
        {
          title: "Integrated messaging with WhatsApp",
          desc: "Engage customers directly on Thailand's most popular messaging platforms for support and marketing.",
        },
        {
          title: "Sophisticated lead tracking",
          desc: "Capture, monitor, and attribute leads effectively using integrated web forms and UTM parameters.",
        },
        {
          title: "Omnichannel command centre",
          desc: "Consolidate conversations from calls, social media, email, and messaging apps into one interface.",
        },
        {
          title: "Intelligent automation",
          desc: "Configure rules to automatically route leads, trigger reminders, and execute actions based on timing or behaviour.",
        },
        {
          title: "Insightful dashboards",
          desc: "Access real-time business intelligence through easily customisable reports and performance metrics.",
        },
        {
          title: "Industry customisation",
          desc: "Offers tailored tools for key Thai sectors like manufacturing, retail, hospitality, and finance.",
        },
      ],
      cta: "Get demo",
    },
    {
      title: "HubSpot CRM",
      desc: "A popular platform globally, HubSpot offers strong sales and marketing alignment features. Its user-friendliness and scalability appeal to many Thai SMEs and startups.",
      img: compareItemImg3,
      alt: "",
      features: [
        {
          title: "Visual sales process design",
          desc: "Easily map out your sales stages using a drag-and-drop interface.",
        },
        {
          title: "Integrated marketing tools",
          desc: "Run and oversee campaigns across multiple digital channels.",
        },
        {
          title: "Generous free version",
          desc: "Provides a solid starting point for small teams at no initial cost.",
        },
        {
          title: "Extensive App marketplace",
          desc: "Connects readily with numerous third-party applications.",
        },
      ],
    },
    {
      title: "Salesforce",
      desc: "A global CRM powerhouse, Salesforce caters well to larger Thai enterprises with complex requirements, offering deep customisation and extensive features.",
      img: compareItemImg4,
      alt: "",
      features: [
        {
          title: "Vast appexchange",
          desc: "Provides access to a wide array of specialised industry apps and integrations.",
        },
        {
          title: "Predictive AI",
          desc: "Leverages AI for forecasting, lead scoring, and smarter decision support.",
        },
        {
          title: "Highly adaptable workflows",
          desc: "Enables the creation of bespoke automation rules for diverse business functions.",
        },
        {
          title: "In-depth analytics",
          desc: "Offers powerful reporting and forecasting capabilities for thorough business analysis.",
        },
      ],
    },
    {
      title: "Zoho CRM",
      desc: "Zoho presents a cost-effective yet capable CRM system popular among small and mid-sized Thai businesses, noted for its mobile accessibility and modular design.",
      img: compareItemImg2,
      alt: "",
      features: [
        {
          title: "AI sales assistant",
          desc: "Uses predictive analytics to guide sales activities and automate tasks.",
        },
        {
          title: "Broad communication channels",
          desc: "Connects with customers via phone, email, social media, and live chat.",
        },
        {
          title: "Flexible module system",
          desc: "Allows businesses to adapt the CRM structure to their specific needs.",
        },
        {
          title: "Team motivation tools",
          desc: "Includes gamification elements like points and leaderboards to encourage engagement.",
        },
      ],
    },
    {
      title: "Microsoft dynamics 365",
      desc: "Ideal for Thai companies heavily invested in the Microsoft ecosystem, Dynamics 365 offers enterprise-level CRM capabilities with native Office and Teams integration.",
      img: compareItemImg5,
      alt: "",
      features: [
        {
          title: "LinkedIn sales navigator link",
          desc: "Enhances lead data and outreach efforts through direct LinkedIn integration.",
        },
        {
          title: "Advanced BI via power BI",
          desc: "Facilitates sophisticated data visualisation and insight sharing across teams.",
        },
        {
          title: "Machine learning insights",
          desc: "Provides AI-driven forecasting and customer behaviour analysis.",
        },
      ],
    },
  ];

  const bestPractice = [
    {
      icon: smartIcon1,
      alt: "",
      heading: "AI-powered efficiency",
      desc: "Automate routine tasks and enhance customer service with features offered by CRM software Philippines.",
    },
    {
      icon: smartIcon2,
      alt: "",
      heading: "Lead management",
      desc: "Centralise lead tracking across platforms — a key feature of many CRM companies in the Philippines.",
    },
    {
      icon: smartIcon3,
      alt: "",
      heading: "Sales pipeline management",
      desc: "Trusted CRM companies in the Philippines offer visual tools to help manage your sales journey.",
    },
    {
      icon: smartIcon4,
      alt: "",
      heading: "Automated workflows",
      desc: "Automate tasks like follow-ups and lead routing, a benefit provided by most CRM software platforms.",
    },
    {
      icon: smartIcon5,
      alt: "",
      heading: "WhatsApp CRM",
      desc: "Essential for businesses seeking to connect with local clients, and often offered by CRM companies in the Philippines.",
    },
    {
      icon: smartIcon6,
      alt: "",
      heading: "Multichannel communication",
      desc: "A core function of CRM software Philippines, unifying email, chat, and social platforms.",
    },
    {
      icon: smartIcon7,
      alt: "",
      heading: "Task and activity management",
      desc: "Plan and prioritise effortlessly with tools from CRM providers Philippines.",
    },
    {
      icon: smartIcon8,
      alt: "",
      heading: "Mobile CRM app",
      desc: "Access your CRM on the go, a must-have from most CRM companies in the Philippines.",
    },
    {
      icon: smartIcon9,
      alt: "",
      heading: "CRM integrations",
      desc: "Connect seamlessly with other business tools, a standout feature of top CRM software Philippines.",
    },
  ];
  const tabContentData = [
    {
      tabContent: [
        {
          heading: "AI-powered lead management",
          content:
            "Capture and nurture leads automatically with AI-driven workflows.",
          alt: "E-commerce CRM",
        },
        {
          heading: "AI support",
          content:
            "Suggest relevant products and offer instant support via chatbots.",
          alt: "E-commerce CRM",
        },
        {
          heading: "Omnichannel engagement",
          content:
            "Centralize customer chats from WhatsApp, email, and social media.",
          alt: "E-commerce CRM",
        },
        {
          heading: "AI insights",
          content:
            "Track conversions and customer preferences with AI insights.",
          alt: "E-commerce CRM",
        },
      ],
      img: realWorldImg1,
      alt: "E-commerce CRM for Thailand",
      subtitle:
        "Enhance online sales performance by leveraging AI-powered CRM for optimised customer journeys and increased conversion rates.",
    },
    {
      tabContent: [
        {
          heading: "AI appointment scheduling",
          content:
            "Automate bookings, rescheduling, and reminders with AI workflows.",
          alt: "Healthcare CRM",
        },
        {
          heading: "AI patient support",
          content: "Provide instant chatbot responses, freeing up staff time.",
          alt: "Healthcare CRM",
        },
        {
          heading: "Patient communication",
          content: "Manage all patient interactions from one unified platform.",
          alt: "Healthcare CRM",
        },
        {
          heading: "Data insights",
          content:
            "Track interactions securely and share reports for compliance needs.",
          alt: "Healthcare CRM",
        },
      ],
      img: realWorldImg2,
      alt: "Healthcare CRM for Thailand",
      subtitle:
        "Improve patient care quality and operational efficiency with an AI-enhanced CRM designed for Thailand's healthcare sector.",
    },
    {
      tabContent: [
        {
          heading: "AI-driven student support",
          content:
            "Provide instant AI responses to queries, enhancing student engagement levels.",
          alt: "Education CRM",
        },
        {
          heading: "Automated workflows",
          content:
            "Automate scheduling, reminders, and tasks with AI for ease.",
          alt: "Education CRM",
        },
        {
          heading: "Omnichannel communication",
          content:
            "Engage students via WhatsApp, email, and portals in one place.",
          alt: "Education CRM",
        },
        {
          heading: "AI-powered insights",
          content:
            "Track engagement and performance for better outcomes and decisions.",
          alt: "Education CRM",
        },
      ],
      img: realWorldImg3,
      alt: "Education CRM for Thailand",
      subtitle:
        "Boost student interaction and streamline academic administration using an AI-powered CRM built for educational institutions.",
    },
    {
      tabContent: [
        {
          heading: "AI-enhanced lead nurturing",
          content:
            "Qualify leads and send personalised property suggestions with AI.",
          alt: "Real Estate CRM",
        },
        {
          heading: "AI property viewing scheduling",
          content:
            "Enable seamless property viewings with automated AI bookings.",
          alt: "Real Estate CRM",
        },
        {
          heading: "Omnichannel communication",
          content:
            "Manage all client interactions from one efficient platform.",
          alt: "Real Estate CRM",
        },
        {
          heading: "Data-driven sales insights",
          content:
            "Use AI to track sales, optimise follow-ups, and boost conversions.",
          alt: "Real Estate CRM",
        },
      ],
      img: realWorldImg4,
      alt: "Real Estate CRM for Thailand",
      subtitle:
        "Drive property sales and enhance lead nurturing processes with an AI-driven CRM specifically configured for the Thai real estate industry.",
    },
  ];
  const cards = [
    {
      heading: "What exactly is CRM software for Thailand?",
      content:
        "Customer relationship management (CRM) software tailored for Thailand provides businesses with a central hub to organise customer interactions, automate essential sales and marketing tasks, and fuel business expansion. It consolidates communication channels, lead progression, and sales activities onto one smart platform.",
    },
    {
      heading: "Why Thai businesses need CRM",
      content:
        "In Thailand's dynamic market, a CRM system is vital. It empowers businesses to cultivate stronger client connections, enhance internal communication, and optimise operational efficiency. Implementing a CRM gives your company a distinct advantage to scale efficiently and deliver outstanding service.",
    },
  ];
  const adaptList = [
    {
      pointer: "All-in-one CRM",
      desc: "Pepper Cloud combines lead management and sales automation into one unified platform—no need for multiple tools.",
      img: bestIcon1,
    },
    {
      pointer: "All-size business",
      desc: "Whether you're a startup, SME or enterprise, our CRM is tailored to suit your business stage and industry.",
      img: bestIcon2,
    },
    {
      pointer: "Affordable pricing",
      desc: "Transparent and cost-effective plans with zero setup charges—built to support Malaysian SMEs and startups.",
      img: bestIcon3,
    },
    {
      pointer: "24/7 local support",
      desc: "Get round-the-clock help from our team who understands the Malaysian market and speaks your language.",
      img: bestIcon4,
    },
    {
      pointer: "Advanced customisation",
      desc: "Tailor the CRM with flexible workflows, custom fields, and pipeline stages to match your unique sales process.",
      img: bestIcon5,
    },
  ];
  const pointers = [
    "Achieve full transparency into your sales pipeline, enabling faster deal closure and smarter strategies.",
    "Consolidate customer information on one platform to boost alignment and satisfaction.",
    "Boost team productivity by automating time-consuming tasks such as follow-ups and reminders.",
    "Build stronger, profitable relationships with personalized, consistent engagement.",
  ];
  return (
    <main>
      <SEO
        title={"Best CRM Software in Thailand | Pepper Cloud"}
        pathname={
          "https://peppercloud.com/country/best-crm-software-in-thailand/"
        }
        keywords=" best crm software in Thailand, crm software Thailand, crm system in Thailand, crm system Thailand, best crm Thailand"
        description={
          "Grow your business with the best CRM software in Thailand. Pepper Cloud CRM helps you manage leads, automate tasks, and engage customers easily."
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is the leading CRM software for small businesses operating in Thailand?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM is specifically engineered for Thai SMEs, providing an affordable, feature-rich platform designed to support growth effectively in the local market.",
                },
              },
              {
                "@type": "Question",
                name: "How can my growing Thai business start using a CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Implementing Pepper Cloud CRM in Thailand is straightforward. Whether launching a startup or scaling an enterprise, our platform simplifies managing leads, sales activities, and client relationships.",
                },
              },
              {
                "@type": "Question",
                name: "What key factors should I consider when selecting a CRM for my business in Thailand?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "a. Future-proof scalability: Choose a CRM capable of expanding alongside your business, handling more data, users, and leads seamlessly. b. Adaptability: Ensure the CRM can be customised to fit your specific industry workflows, sales stages, and operational processes in Thailand. c. Integration power: Verify compatibility with essential tools used in Thailand, such as WhatsApp, Google Workspace, and key marketing software. d. Localised support: Prioritise providers offering accessible, knowledgeable support within Thailand for timely help and smooth onboarding. e. Transparent value: Seek CRM solutions with clear, fair pricing structures that deliver tangible value without unexpected costs.",
                },
              },
              {
                "@type": "Question",
                name: "Is Pepper Cloud CRM a good fit for startup companies in Thailand?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Definitely. Pepper Cloud CRM is highly scalable, simple to deploy, and equipped with powerful automation features designed to accelerate growth for Thai startups.",
                },
              },
              {
                "@type": "Question",
                name: "Can Pepper Cloud CRM connect with the tools I already use?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, Pepper Cloud CRM integrates smoothly with common business tools including email platforms, web forms, calendars, and various third-party applications relevant to the Thai market.",
                },
              },
              {
                "@type": "Question",
                name: "How does Pepper Cloud CRM handle data security?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "We employ robust, multi-layered security measures and protocols to safeguard your customer data and help ensure compliance with relevant regulations.",
                },
              },
              {
                "@type": "Question",
                name: "What CRM systems are commonly adopted in Thailand?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "While several international CRMs have a presence, Pepper Cloud CRM is rapidly gaining preference among Thai SMEs. This is due to its intuitive design, competitive pricing, and features specifically valuable in the Thai context, such as strong WhatsApp integration and dedicated regional support.",
                },
              },
              {
                "@type": "Question",
                name: "Is Pepper Cloud CRM expensive?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "No, Pepper Cloud CRM offers flexible pricing models suitable for businesses of all sizes in Thailand, from new startups to established enterprises. You invest only in the features required, ensuring it's a cost-effective solution for improving sales, marketing, and support efficiency.",
                },
              },
              {
                "@type": "Question",
                name: "What defines the best CRM for a small business?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "An ideal CRM for small businesses should be budget-friendly, user-friendly, and scalable. Pepper Cloud CRM meets these criteria perfectly for small businesses in Thailand, offering an intuitive interface, valuable AI automation, and seamless integration with key communication tools like WhatsApp effectively manage leads and build customer loyalty.",
                },
              },
            ],
          },
        ]}
      />
      <section className={classes.heroSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h1
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-72 color-black1"
            >
              The best CRM software in{" "}
              <img className="countryLogo" src={thailand} alt="thailand" />{" "}
              <span className="countryHighlight">Thailand</span> for your
              business
            </motion.h1>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-inter-regular font-18 color-black2 mt10"
              //   style={{ color: "#A2BED3" }}
            >
              Pepper Cloud CRM, Thailand's choice for streamlining sales
              processes, automating key workflows, and building lasting customer
              relationships. Move beyond basic tools and manage every
              interaction effectively. Key advantages include:
            </motion.p>
            <div className={classes.listContainer}>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Intelligent process automation
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Integrated WhatsApp
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  A single view of every customer journey
                </p>
              </div>
            </div>
            <div className="buttonContaienr mt40">
              <Link
                to="/contact/"
                className="primaryButton font-20 font-wix-medium font-white"
              >
                Book a free demo
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.countrySection}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              A quick guide about best CRM software in Thailand
            </motion.h2>
          </div>
          <div className="cards">
            {cards.map((card) => (
              <div className="card">
                <p className="font-24 font-wix-semibold font-white">
                  {card.heading}
                </p>
                <p className="font-wix-regular font-18 font-white">
                  {card.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className={classes.adaptFeatures}>
        <div className="container">
          <div className="header">
            <motion.h2
              className="font-wix-medium font-56 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Why Pepper Cloud is the best CRM software in the Thailand
            </motion.h2>
          </div>
        </div>
        <Swiper
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: "auto",
              freeMode: true,
              // grabCursor: false,
              spaceBetween: 15,
              // autoplay: false,
              // modules: [],
            },
            // For larger screens (desktop)
            // 768: {
            //   slidesPerView: "auto",
            //   slidesPerGroup: 3,
            //   spaceBetween: 30,
            //   grabCursor: true,
            // },
          }}
          className={classes.adaptSlider}
          slidesPerView={3.3}
          // centeredSlides={true}
          spaceBetween={30}
          grabCursor={true}
          loop={true}
          speed={5000}
          modules={[Autoplay]}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
        >
          {adaptList.map((point, index) => (
            <SwiperSlide className={classes.adaptsBox}>
              <div className={classes.adaptBoxHeader}>
                <img
                  alt={point.pointer}
                  className={classes.adaptBoxImg}
                  src={point.img}
                />
                <p className="font-24 font-wix-semibold ">{point.pointer}</p>
              </div>
              <div className={classes.adaptDescription}>
                <p className="font-wix-regular font-18  ">{point.desc}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <section className={classes.growingBusiness}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Everything you need to sell smarter, faster, and better
            </motion.h2>
          </div>
          <div className="body">
            {bestPractice.map((practice) => (
              <div className={classes.practiceCard}>
                <img src={practice.icon} alt={practice.heading} />
                <p className="font-wix-semibold font-24 font-white">
                  {practice.heading}
                </p>
                <p
                  className="font-wix-medium font-16"
                  style={{ color: "#E9F4FE" }}
                >
                  {practice.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className={classes.absoulteCard}>
          {/* <TruestedSection background={true} /> */}
        </div>
      </section>
      <section className={classes.tabsSection}>
        <div className="container">
          <motion.div
            initial={{ opacity: 1, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={classes.supportBox}
            // style={{ background: point.background }}
          >
            <div className={classes.broadcastLeftContainer}>
              <p className="font-40 font-wix-regular font-white">
                Key advantages of using a CRM tool for your growing Thai
                business
              </p>
              <div className={classes.pointers}>
                {pointers.map((pointer) => (
                  <div className={classes.cardPointer}>
                    <LazyImage
                      source={whiteCheckCircle}
                      className={classes.pointerImg}
                      alt={"pointer"}
                    />
                    <p className="font-inter-regular font-18 font-white">
                      {pointer}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className={classes.broadcastRightContainer}>
              <LazyImage
                source={benefitImg}
                alt={
                  "Key advantages of using a CRM tool for your growing Thai business"
                }
                className={classes.broadcastImg}
              />
            </div>
          </motion.div>
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 color-black1"
            >
              Real-world CRM applications across Thai industries
            </motion.h2>
            <div className={classes.tabsContainer}>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 0 && "active"
                )}
                onClick={() => setActiveRealWorld(0)}
              >
                E-commerce
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 1 && "active"
                )}
                onClick={() => setActiveRealWorld(1)}
              >
                Healthcare
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 2 && "active"
                )}
                onClick={() => setActiveRealWorld(2)}
              >
                Education
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 3 && "active"
                )}
                onClick={() => setActiveRealWorld(3)}
              >
                Real estate
              </div>
            </div>
          </div>
          <div className={classes.tabCard}>
            <div className={classes.tabCardLeftContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <div>
                      <motion.p
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.3 }}
                        className="font-wix-regular font-18 color-black2"
                      >
                        {listItem.subtitle}
                      </motion.p>
                      <div className={classes.benfitListContainer}>
                        {listItem.tabContent.map((item) => (
                          <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.3 }}
                            className={classes.benfitListItem}
                          >
                            <LazyImage
                              source={greenCheckCircle}
                              className={classes.benfitIcon}
                              alt={item.alt}
                            />
                            <div className={classes.benfitListItemContent}>
                              <p className="font-wix-semibold font-20 color-black1">
                                {item.heading}
                              </p>
                              <p className="font-wix-regular font-16 color-black2">
                                {item.content}
                              </p>
                            </div>
                          </motion.div>
                        ))}
                      </div>
                    </div>
                  )
              )}
            </div>
            <div className={classes.tabCardRightContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <motion.div
                      initial={{ opacity: 1, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                      // className={classes.aiSectionRight}
                    >
                      <LazyImage
                        source={listItem.img}
                        alt={listItem.alt}
                        width={"100%"}
                      />
                    </motion.div>
                  )
              )}
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-black1"
            >
              Top 5 CRM software choices for businesses in Thailand
            </motion.h2>
          </div>
          <div className={classes.compareSectionContainer}>
            <div className={classes.compareSectionContainerLeftSection}>
              {compareItems.map((item, index) => (
                <div
                  className={clsx(
                    classes.compareSectionLeftItem,
                    activeCompare === `#section${index}` && "active"
                  )}
                  onClick={() => {
                    scrollToSection(`#section${index}`);
                    setActiveCompare(`#section${index}`);
                  }}
                >
                  <a
                    href={`#section${index}`}
                    className={clsx(
                      "font-22 font-wix-medium font-black1",
                      activeCompare === `#section${index}` && "font-wix-bold"
                    )}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.compareSectionContainerRightSection}>
              {compareData.map((data, outerIndex) => (
                <div
                  className={classes.compareItemContainer}
                  id={`#section${outerIndex}`}
                >
                  <h3
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-40 font-wix-semibold font-black1"
                  >
                    {data.title}
                  </h3>
                  <p
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-inter-regular font-18 font-black1"
                  >
                    {data.desc}
                  </p>
                  <img src={data.img} className="productImage" alt={data.alt} />
                  <div className={classes.faqsContainer}>
                    {data.features.map((faq, innerIndex) => (
                      <motion.div
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                        transition={{ duration: 1, delay: innerIndex * 0.01 }}
                        className={classes.faqBox}
                        onClick={() =>
                          setActiveAccordian(
                            `${outerIndex}-${innerIndex}` === activeAccordian
                              ? -1
                              : `${outerIndex}-${innerIndex}`
                          )
                        }
                      >
                        <div className={classes.header}>
                          <h3 className="font-20 font-wix-semibold">
                            {faq.title}
                          </h3>
                          <img
                            src={downArrow}
                            alt="Arrow"
                            className={clsx(
                              classes.downArrow,
                              `${outerIndex}-${innerIndex}` ===
                                activeAccordian && "active"
                            )}
                          />
                        </div>
                        <Collapse
                          className={classes.body}
                          in={activeAccordian === `${outerIndex}-${innerIndex}`}
                        >
                          <p className="font-18 font-inter-regular color-black2">
                            {faq.desc}
                          </p>
                        </Collapse>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <TruestedSection />
      <section className={classes.stripSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h3
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-24 font-black1"
            >
              Best CRM with WhatsApp integration - Trusted by SMEs globally
            </motion.h3>
          </div>
        </div>
        <Swiper
          className={classes.partnerSlider}
          slidesPerView="auto"
          spaceBetween={60}
          loop={true}
          speed={3000}
          modules={[Autoplay]}
          allowTouchMove={false}
          autoplay={{
            delay: 100,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 20,
            },
            // For larger screens (desktop)
            768: {
              freeMode: false,
              autoplay: {
                delay: 100,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              },
              speed: 3000,
              loop: true,
              allowTouchMove: true,
            },
          }}
        >
          {partners.map((partner) => (
            <SwiperSlide className={classes.partnerSlide}>
              <img src={partner.icon} alt={partner.alt} />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <div className={classes.testimonials}>
        <TestimonialSlider
          noButton={true}
          heading={"Real stories. Real results."}
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
        />
      </div>
      <AllCountries />
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#eaffff"}
          heading={"FAQs - choosing the best CRM software in Thailand"}
          faqs={faqs}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Optimise your sales and scale faster with Thailand's leading CRM
              platform.
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/"
            >
              Book a free demo
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Thailand;
